import { FAPI_SERVICE_CASE_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const apiClient = new HttpClient(environment.adminFAPIUrl)

interface UploadExcludeMachinesListParams {
  countryId: string
  fileName: string
  file: File
}

export const adminServiceCaseService = {
  async uploadExcludeMachinesList({
    countryId,
    fileName,
    file,
  }: UploadExcludeMachinesListParams) {
    const formData = new FormData()
    formData.append('FormFile', file)
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/excluded-upload`

    return apiClient.post(url, {
      body: formData,
      params: {
        countryId,
        fileName,
      },
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
  },

  async downloadExcludedMachinesList(countryId: string) {
    const url = `${FAPI_SERVICE_CASE_ENDPOINT}/excluded-download`

    return apiClient.get(url, {
      params: {
        countryId,
      },
    })
  },
}
